// Recovered compiled webpack factory 60178. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { p: () => n });
  function n(t) {
    let e;
    return () => (void 0 === e && (e = t()), e);
  }
}
